import {object, string, number } from "yup";

const bookingSchema = object({
    eventId: number().required(),
    eventVendorId: number().required(),
    memberId: number().required(),
    slot: string().required()
});

export default bookingSchema;